/** Charge.ChargeTypes on the API */
export const chargeTypeOptions = [
    { value: 'cost_per_change', label: 'Cost per change' },
    { value: 'monthly_cost', label: 'Monthly cost' },
];

export const chargeTypeLabel = (value?: string) =>
    chargeTypeOptions.find((option) => option.value === value)?.label ?? value;

/** ChargeFilterSet.processed */
export const processedOptions = [
    { value: 'true', label: 'Processed' },
    { value: 'false', label: 'Pending' },
];

type ScopeParty = { id?: number; name?: string } | undefined;

/**
 * A charge points at either a change instance or a service item, and the two
 * are serialised differently — a change instance carries the item beside it,
 * a service item is the item. Both light serializers carry the consumer team
 * and the application, so everything the row shows is reachable either way.
 */
export const scopeOf = (
    record: any,
): {
    serviceItem: ScopeParty;
    consumer: ScopeParty;
    application: ScopeParty;
    service: ScopeParty;
} => {
    const scope = record?.scope;
    const data = scope?.data;

    if (!data) return { serviceItem: undefined, consumer: undefined, application: undefined, service: undefined };

    return {
        serviceItem:
            scope.scope === 'change_instance' ? data.service_item : { id: data.id, name: data.name },
        consumer: data.consumer_team,
        application: data.application,
        service: data.service,
    };
};
